import { render, staticRenderFns } from "./GraficoProdutividadeMedia.vue?vue&type=template&id=0addc1dc&lang=pug"
import script from "./GraficoProdutividadeMedia.vue?vue&type=script&lang=js"
export * from "./GraficoProdutividadeMedia.vue?vue&type=script&lang=js"
import style0 from "./GraficoProdutividadeMedia.vue?vue&type=style&index=0&id=0addc1dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports